export default "__VITE_PUBLIC_ASSET__1f5e2d50__"